import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchServices } from '../modules/Service/actions';

const mapStateToProps = ({ service }) => {
    const { loadingServices, services } = service;

    return {
        loadingServices,
        services
    };
};

const mapDispatchToProps = {
    fetchServices
};

const withServices = WrappedComponent => {
    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(class extends Component {
        componentDidMount() {
            const { fetchServices, loadingServices } = this.props;

            if (loadingServices) {
                return;
            }

            fetchServices();
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                />
            );
        }
    });
};

export default withServices;
